import { defineComponent as z, computed as f, useSlots as j, unref as a, openBlock as l, createElementBlock as m, createVNode as y, mergeProps as c, withCtx as s, renderSlot as i, createElementVNode as N, normalizeClass as w, normalizeStyle as h, createBlock as b, createCommentVNode as x } from "vue";
import n from "./ghl-ui.es205.js";
import "./ghl-ui.es206.js";
import r from "./ghl-ui.es207.js";
const C = {
  key: 0,
  class: "ghl-avatar-container"
}, F = z({
  name: "UIAvatar",
  inheritAttrs: !1
}), M = z({
  ...F,
  props: {
    size: {
      type: [Number, String],
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String,
      default: void 0
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    },
    indicator: {
      type: String,
      required: !1
    }
  },
  setup(e) {
    const d = e, g = (t) => typeof t == "number" ? t : {
      small: 24,
      medium: 32,
      large: 40
    }[t] || t, k = f(() => {
      const t = g(d.size);
      return Math.floor(typeof t == "number" ? t * 0.42 : t);
    }), v = (t) => typeof t == "number" ? { width: `${t + 4}px`, height: `${t + 4}px` } : {
      small: { width: "34px", height: "34px" },
      medium: { width: "40px", height: "40px" },
      large: { width: "46px", height: "46px" }
    }[t] || { width: `${t + 4}px`, height: `${t + 4}px` }, S = f(() => v(d.size)), $ = j(), o = (t) => !isNaN(t) && !isNaN(parseFloat(t));
    return (t, u) => a($).overlay ? (l(), m("div", C, [
      y(a(r), c(t.$attrs, {
        class: "ghl-avatar",
        style: e.style,
        src: a(n)(e.src) ? "undefined" : e.src,
        "fallback-src": e.fallbackSrc,
        round: e.round,
        "object-fit": e.objectFit,
        size: e.size
      }), {
        default: s(() => [
          i(t.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      N("div", {
        class: w(["ghl-avatar-backdrop", [
          `ghl-avatar-backdrop-${e.size}`,
          e.round ? "ghl-avatar-round-backdrop" : null
        ]]),
        style: h({
          width: o(e.size) ? e.size + "px" : null,
          height: o(e.size) ? e.size + "px" : null
        })
      }, [
        i(t.$slots, "overlay")
      ], 6)
    ])) : e.indicator ? (l(), m("div", {
      key: 1,
      class: "n-avatar-with-indicator",
      style: h(S.value)
    }, [
      y(a(r), c(t.$attrs, {
        class: "ghl-avatar",
        style: e.style,
        src: a(n)(e.src) ? "undefined" : e.src,
        "fallback-src": e.fallbackSrc,
        round: e.round,
        "object-fit": e.objectFit,
        size: e.size
      }), {
        default: s(() => [
          i(t.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      e.indicator ? (l(), b(a(r), {
        key: 0,
        size: k.value,
        src: e.indicator,
        round: e.round,
        class: "indicator"
      }, null, 8, ["size", "src", "round"])) : x("", !0)
    ], 4)) : (l(), b(a(r), c({ key: 2 }, t.$attrs, {
      class: "default-avatar",
      style: e.style,
      src: a(n)(e.src) ? "undefined" : e.src,
      "fallback-src": e.fallbackSrc,
      round: e.round,
      "object-fit": e.objectFit,
      size: e.size
    }), {
      default: s(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]));
  }
}), I = M;
export {
  I as default
};
